import { Stack } from "@mui/material";
import { Outlet } from "react-router-dom";
import { menuItems } from "./constants/menuItems";
import DetailMenuItem from "./components";
import ProductDetails from "src/pages/ProductDetails";
import WhiteCard from "../WhiteCard";
import { useMemo } from "react";

const ProductDetailsMenu = () => {
  const width = useMemo(() => window.innerWidth - 16, []);

  return (
    <Stack gap={3}>
      <ProductDetails />
      <Stack direction="row" sx={{ width: width - 100 }} gap={2}>
        <Stack sx={{ width: "100%", minWidth: 0 }}>
          <Outlet />
        </Stack>
        <WhiteCard
          sx={{
            width: 200,
            height: "fit-content",
            position: "sticky",
          }}
          gap={2}
        >
          {menuItems.map((item) => (
            <DetailMenuItem key={item.name} item={item} />
          ))}
        </WhiteCard>
      </Stack>
    </Stack>
  );
};

export default ProductDetailsMenu;
